<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>


    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char20">
                <label class="label-caption">Protocolo</label>
                <div class="field-label field-label-center field-label--destaque">{{ objView?.protocolo }}</div>
            </div>

            <div class="form-item-char40">
                <label class="label-caption">Documento</label>
                <div class="field-label">{{ objView?.nmepdocmodelo }}</div>
            </div>

            <div class="form-item-char30">
                <label class="label-caption">S.I.M.</label>
                <div class="field-label">{{ objView?.nmsim }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Estabelecimento</label>
                <div class="field-label">{{ objView?.nmestabelecimento }}</div>
            </div>
            
            <div class="form-item-char10">
                <label class="label-caption">Nro S.I.M.</label>
                <div class="field-label field-label-center field-label--destaque">{{ objView?.nrosim }}</div>
            </div>
        </div>

        <div class="row-start row-space">
            <div class="form-item-char10">
                <label class="label-caption">Data</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView?.dtdoc) }}</div>
            </div>
            
            <div class="form-item-char05">
                <label class="label-caption">Hora</label>
                <div class="field-label field-label-center">{{ Funcoes.formatTimeFromJson(objView?.hrdoc) }}</div>
            </div>
            
            <div class="form-item-char30">
                <label class="label-caption">Situação</label>
                <div class="field-label">{{ objView.nmstatus }}</div>
            </div>

            <button v-if="!objView.idlaudo" class="btn-small" @click="visualizarEmissao">Visualizar</button>
            <button v-else class="btn-small" @click="visualizarLaudo">Laudo</button>
            
            <button class="btn-small" @click="showModalAssinaturas=true">Assinaturas</button>
            <button v-if="props.idAssinatura > 0" class="btn-small" @click="assinarDocumento">Assinar</button>
            <button v-if="objView.idlaudo" class="btn-small" @click="onClickEmail">E-Mail</button>
            <button class="btn-small" @click="closePage">Retornar</button>
        </div>
    </div>


    <div v-if="lsAnexos.length>0" class="form-edit-page row-space">
        <AnexoGrid
            titulo="Anexos vinculados"
            :anexos="lsAnexos"
            :permite-remover="false"
        />
    </div>


    <AssinaturaPendenteListaModal
        v-if="showModalAssinaturas"
        :refId="props.idView"
        :refTable="'DOC'"
        @close="showModalAssinaturas = false"
    />

    
    <DialogOkModal 
        v-if="showOkEmail" 
        :message="msgOkModal" 
        @close="showOkEmail=false" 
        @confirmed="showOkEmail=false"
    />

    
    <DialogOkModal 
        v-if="showOkModal" 
        :message="msgOkModal" 
        @close="closePage(true)" 
        @confirmed="closePage(true)"
    />


    <EmailLaudoModal
        v-if="showEmailModal"
        @close="showEmailModal = false"
        @confirm="enviarEmailLaudo"
    />


    <SenhaModal ref="senhaModalRef" />
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarAssinatura } from '@/models/assinatura';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import AnexoGrid from '@/components/anexos/AnexoGrid.vue';
import AssinaturaPendenteListaModal from '@/components/modals/AssinaturaPendenteListaModal.vue';
import DialogOkModal from '@/components/modals/DialogOkModal.vue';
import EmailLaudoModal from '@/components/modals/EmailLaudoModal.vue';
import SenhaModal from '@/components/modals/SenhaModal.vue';

const emit = defineEmits(['close','save']);
const props = defineProps({
    idAssinatura: {type: Number, default: 0},
    idView: {type: Number, default: 0},
})

const isLoading = ref(false);
const lsAnexos = ref([]);
const msgAlerta = ref(null);
const msgOkModal = ref("Assinatura efetuada com sucesso");
const objAssinatura = ref(criarAssinatura());
const objView = ref({});
const senhaModalRef = ref(null);
const showEmailModal = ref(false);
const showModalAssinaturas = ref(false);
const showOkEmail = ref(false);
const showOkModal = ref(false);


async function assinarDocumento(){
    try{
        msgAlerta.value=null;

        const senhaDigitada = await senhaModalRef.value.showModal();
        if (!senhaDigitada) return;
        
        isLoading.value=true;

        objAssinatura.value.idep = globalStore.idep;
        objAssinatura.value.idusuario = globalStore.idusuario;
        objAssinatura.value.idsessao = globalStore.idlogin;
        objAssinatura.value.nmusuario = globalStore.nmusuario;
        objAssinatura.value.vssistema = `${globalStore.appname} vs. ${globalStore.appver}`;
        objAssinatura.value.ass_conteudo = `REF:DOC|IDREF:${objView.value.id}|PROT:${objView.value.protocolo}`;
        objAssinatura.value.ass_senha = senhaDigitada;
        objAssinatura.value.ass_tipoauth = 'senha pessoal via sistema WEB';
        objAssinatura.value.doc_idorigem = objView.value.id;
        objAssinatura.value.doc_tipo = 'DOC';
        objAssinatura.value.acao = 'registroAssinaturaPendente';
        objAssinatura.value.acao_id = props.idAssinatura;

        const respAss = await Api.genericPut('/doc/assinar', objAssinatura.value);
        if (respAss.bolok === 1){
            showOkModal.value = true;
        } else {
            msgAlerta.value=`ATENÇÃO: ${respAss.erro}`;
        }
    } catch (error) {msgAlerta.value=`ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}


function closePage(emitSave){
    if (emitSave==true) {emit('save');}
    emit('close');
}


async function enviarEmailLaudo(payload){
    try {
        msgAlerta.value = null;
        isLoading.value = true;
        showEmailModal.value = false;

        await Api.genericPost('/doc/email', {
            id: objView.value.id,
            strparam1: payload.usarEnvolvidos ? '' : payload.emails
        });
        msgOkModal.value='Email adicionado a fila de envios!';
        showOkEmail.value=true;

    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function lerDados() {
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const req = await Api.genericPost('/lsdoc/doc', {
            idep: globalStore.idep,
            id: props.idView,
        });
        Object.assign(objView.value, req[0]);
        await lerAnexos();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value = false;}
}


async function lerAnexos(){
    try{
        const reqAnexos = await Api.genericPost('/lsdoc/doc/anexos', {
            idep: globalStore.idep,
            idreferencia: props.idView
        });
        lsAnexos.value = reqAnexos;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;}
}


function onClickEmail(){
    msgAlerta.value = null;
    showEmailModal.value = true;
}


async function visualizarEmissao(){
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const dados = {
            nmrelatorio: objView.value.nmrelatorio,
            id: objView.value.id,
            idep: globalStore.idep,
            idsim: globalStore.idsim,
            idusuario: globalStore.idusuario
        };
        const response = await Api.genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


async function visualizarLaudo() {
    if (!objView.value.idlaudo){msgAlerta.value='Laudo não disponível!'; return;}
    try {
        msgAlerta.value = null;
        isLoading.value = true;

        const r = await Api.genericPost('/operacoes/solicitar/download', { id: objView.value.idlaudo });
        if (r.bolok === 1 && r.download_url) {
            window.open(r.download_url, '_blank');
        } else {
            msgAlerta.value = `ATENÇÃO: ${r.erro || 'Não foi possível abrir o anexo.'}`;
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


onMounted(lerDados)
</script>